import { Prices, YieldValue } from '~/types'

export const ETH_PER_BLOCK_REWARD = 3
export const SNAPSHOT_INTERVAL = 1 * 24 * 60 * 60 // daily [seconds]

export const fetchETHYield = () =>
  fetch('https://www.etherchain.org/api/miningEstimator')
    .then(r => r.json())
    .then((json:{blocktime: any, difficulty: any, hashrate: any}) => ({
      ...json,
      blockreward: ETH_PER_BLOCK_REWARD,
      ethphs: ETH_PER_BLOCK_REWARD / json.blocktime / json.hashrate, // eth per hash per second
    } as YieldValue))

export const fetchETHToFiat = () =>
  fetch('https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD,EUR,CZK&extraParams=future-cloud-mining')
    .then(r => r.json())

export const fetchPrices = () =>
  fetch('https://min-api.cryptocompare.com/data/price?fsym=EUR&tsyms=BTC,ETH,LTC,EUR,USD,CZK&extraParams=future-cloud-mining')
    .then((r): Promise<Prices> => r.json())



// WEBPACK FOOTER //
// ./src/utils/coinApi.ts